import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatListModule } from '@angular/material/list';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';

@NgModule({
	imports: [
		CommonModule,
		MatRippleModule,
		MatIconModule,
		MatButtonModule,
		MatCheckboxModule,
		MatInputModule,
		MatDatepickerModule,
		MatTabsModule,
		MatSidenavModule,
		MatSelectModule,
		MatExpansionModule,
		MatSlideToggleModule,
		MatProgressSpinnerModule,
		MatDialogModule,
		MatSnackBarModule,
		MatRadioModule,
		MatListModule,
		MatBottomSheetModule,
		MatMenuModule,
		MatBadgeModule,
	],
	exports: [
		CommonModule,
		MatRippleModule,
		MatIconModule,
		MatButtonModule,
		MatCheckboxModule,
		MatInputModule,
		MatDatepickerModule,
		MatTabsModule,
		MatSidenavModule,
		MatSelectModule,
		MatExpansionModule,
		MatSlideToggleModule,
		MatProgressSpinnerModule,
		MatDialogModule,
		MatSnackBarModule,
		MatRadioModule,
		MatListModule,
		MatBottomSheetModule,
		MatMenuModule,
		MatBadgeModule,
	],
})
export class MaterialModule { }
